import { ROOT, SET_SEEN_A_NOTICE, SET_SEEN_ALL_NOTICE } from "@/_helpers/constant.js";

import { requestOptions, handleResponse } from "@/_helpers";

function seenNotice(noticeId) {
  return fetch(ROOT + SET_SEEN_A_NOTICE, requestOptions.post({ noticeId }))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function seenAllNotice(noticeId) {
    return fetch(ROOT + SET_SEEN_ALL_NOTICE, requestOptions.post({ noticeId }))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
export const notificationService = {
    seenNotice,
    seenAllNotice
};
